export const iconFontAwesomeTimeStopwatch = (
	<i className="fa-solid fa-stopwatch"></i>
);
